import script from "./BillingSkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BillingSkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./BillingSkeletonLoader.vue?vue&type=style&index=0&id=363f9d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-363f9d12"]])

export default __exports__